function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import "core-js/modules/es.array.concat.js";
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import React, { Component } from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
import moment from 'moment'; // eslint-disable-line import/named
import dateMath from '@elastic/datemath';
import { useEuiMemoizedStyles } from '../../../services';
import { isObject } from '../../../services/predicate';
import { EuiI18nConsumer } from '../../context';
import { EuiDatePickerRange } from '../date_picker_range';
import { EuiFormControlLayout } from '../../form';
import { RenderI18nTimeOptions } from './time_options';
import { PrettyDuration, showPrettyDuration } from './pretty_duration';
import { AsyncInterval } from './async_interval';
import { EuiSuperUpdateButton } from './super_update_button';
import { EuiQuickSelectPopover } from './quick_select_popover/quick_select_popover';
import { EuiDatePopoverButton } from './date_popover/date_popover_button';
import { EuiAutoRefresh, EuiAutoRefreshButton } from '../auto_refresh/auto_refresh';
import { euiSuperDatePickerStyles } from './super_date_picker.styles';
function isRangeInvalid(start, end) {
  if (start === 'now' && end === 'now') {
    return true;
  }
  var startMoment = dateMath.parse(start);
  var endMoment = dateMath.parse(end, {
    roundUp: true
  });
  var isInvalid = !startMoment || !endMoment || !startMoment.isValid() || !endMoment.isValid() || !moment(startMoment).isValid() || !moment(endMoment).isValid() || startMoment.isAfter(endMoment);
  return isInvalid;
}
export var EuiSuperDatePickerInternal = /*#__PURE__*/function (_Component) {
  function EuiSuperDatePickerInternal() {
    var _this;
    _classCallCheck(this, EuiSuperDatePickerInternal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, EuiSuperDatePickerInternal, [].concat(args));
    _defineProperty(_this, "asyncInterval", void 0);
    _defineProperty(_this, "state", {
      prevProps: {
        start: _this.props.start,
        end: _this.props.end
      },
      start: _this.props.start,
      end: _this.props.end,
      isInvalid: isRangeInvalid(_this.props.start, _this.props.end),
      hasChanged: false,
      showPrettyDuration: showPrettyDuration(_this.props.start, _this.props.end, _this.props.commonlyUsedRanges),
      isStartDatePopoverOpen: false,
      isEndDatePopoverOpen: false
    });
    _defineProperty(_this, "setTime", function (_ref) {
      var end = _ref.end,
        start = _ref.start;
      var isInvalid = isRangeInvalid(start, end);
      _this.setState({
        start: start,
        end: end,
        isInvalid: isInvalid,
        hasChanged: !(_this.state.prevProps.start === start && _this.state.prevProps.end === end)
      });
      if (!_this.props.showUpdateButton) {
        _this.props.onTimeChange({
          start: start,
          end: end,
          isQuickSelection: false,
          isInvalid: isInvalid
        });
      }
    });
    _defineProperty(_this, "componentDidMount", function () {
      if (!_this.props.isPaused) {
        _this.startInterval(_this.props.refreshInterval);
      }
    });
    _defineProperty(_this, "componentDidUpdate", function () {
      _this.stopInterval();
      if (!_this.props.isPaused) {
        _this.startInterval(_this.props.refreshInterval);
      }
    });
    _defineProperty(_this, "componentWillUnmount", function () {
      _this.stopInterval();
    });
    _defineProperty(_this, "setStart", function (start) {
      _this.setTime({
        start: start,
        end: _this.state.end
      });
    });
    _defineProperty(_this, "setEnd", function (end) {
      _this.setTime({
        start: _this.state.start,
        end: end
      });
    });
    _defineProperty(_this, "applyTime", function () {
      _this.props.onTimeChange({
        start: _this.state.start,
        end: _this.state.end,
        isQuickSelection: false,
        isInvalid: false
      });
    });
    _defineProperty(_this, "applyQuickTime", function (_ref2) {
      var start = _ref2.start,
        end = _ref2.end;
      _this.setState({
        showPrettyDuration: showPrettyDuration(start, end, _this.props.commonlyUsedRanges)
      });
      _this.props.onTimeChange({
        start: start,
        end: end,
        isQuickSelection: true,
        isInvalid: false
      });
    });
    _defineProperty(_this, "hidePrettyDuration", function () {
      _this.setState({
        showPrettyDuration: false,
        isStartDatePopoverOpen: true
      });
    });
    _defineProperty(_this, "onStartDatePopoverToggle", function () {
      _this.setState(function (prevState) {
        return {
          isStartDatePopoverOpen: !prevState.isStartDatePopoverOpen
        };
      });
    });
    _defineProperty(_this, "onStartDatePopoverClose", function () {
      _this.setState({
        isStartDatePopoverOpen: false
      });
    });
    _defineProperty(_this, "onEndDatePopoverToggle", function () {
      _this.setState(function (prevState) {
        return {
          isEndDatePopoverOpen: !prevState.isEndDatePopoverOpen
        };
      });
    });
    _defineProperty(_this, "onEndDatePopoverClose", function () {
      _this.setState({
        isEndDatePopoverOpen: false
      });
    });
    _defineProperty(_this, "onRefreshChange", function (_ref3) {
      var refreshInterval = _ref3.refreshInterval,
        intervalUnits = _ref3.intervalUnits,
        isPaused = _ref3.isPaused;
      _this.stopInterval();
      if (!isPaused) {
        _this.startInterval(refreshInterval);
      }
      if (_this.props.onRefreshChange) {
        _this.props.onRefreshChange({
          refreshInterval: refreshInterval,
          isPaused: isPaused,
          intervalUnits: intervalUnits
        });
      }
    });
    _defineProperty(_this, "stopInterval", function () {
      if (_this.asyncInterval) {
        _this.asyncInterval.stop();
      }
    });
    _defineProperty(_this, "startInterval", function (refreshInterval) {
      var onRefresh = _this.props.onRefresh;
      if (onRefresh) {
        var handler = function handler() {
          var _this$props = _this.props,
            start = _this$props.start,
            end = _this$props.end;
          onRefresh({
            start: start,
            end: end,
            refreshInterval: refreshInterval
          });
        };
        _this.asyncInterval = new AsyncInterval(handler, refreshInterval);
      }
    });
    _defineProperty(_this, "renderQuickSelect", function () {
      var _this$props2 = _this.props,
        start = _this$props2.start,
        end = _this$props2.end,
        customQuickSelectPanels = _this$props2.customQuickSelectPanels,
        customQuickSelectRender = _this$props2.customQuickSelectRender,
        commonlyUsedRanges = _this$props2.commonlyUsedRanges,
        timeOptions = _this$props2.timeOptions,
        dateFormat = _this$props2.dateFormat,
        onRefreshChange = _this$props2.onRefreshChange,
        recentlyUsedRanges = _this$props2.recentlyUsedRanges,
        refreshInterval = _this$props2.refreshInterval,
        refreshMinInterval = _this$props2.refreshMinInterval,
        refreshIntervalUnits = _this$props2.refreshIntervalUnits,
        isPaused = _this$props2.isPaused,
        isDisabled = _this$props2.isDisabled;
      return ___EmotionJSX(EuiQuickSelectPopover, {
        applyRefreshInterval: onRefreshChange ? _this.onRefreshChange : undefined,
        applyTime: _this.applyQuickTime,
        commonlyUsedRanges: commonlyUsedRanges,
        customQuickSelectPanels: customQuickSelectPanels,
        customQuickSelectRender: customQuickSelectRender,
        dateFormat: dateFormat,
        end: end,
        isDisabled: !!isDisabled,
        isPaused: isPaused,
        recentlyUsedRanges: recentlyUsedRanges,
        refreshInterval: refreshInterval,
        refreshMinInterval: refreshMinInterval,
        intervalUnits: refreshIntervalUnits,
        start: start,
        timeOptions: timeOptions
      });
    });
    _defineProperty(_this, "renderDatePickerRange", function () {
      var _this$state = _this.state,
        end = _this$state.end,
        hasChanged = _this$state.hasChanged,
        isEndDatePopoverOpen = _this$state.isEndDatePopoverOpen,
        isInvalid = _this$state.isInvalid,
        isStartDatePopoverOpen = _this$state.isStartDatePopoverOpen,
        showPrettyDuration = _this$state.showPrettyDuration,
        start = _this$state.start;
      var _this$props3 = _this.props,
        isQuickSelectOnly = _this$props3.isQuickSelectOnly,
        showUpdateButton = _this$props3.showUpdateButton,
        commonlyUsedRanges = _this$props3.commonlyUsedRanges,
        canRoundRelativeUnits = _this$props3.canRoundRelativeUnits,
        timeOptions = _this$props3.timeOptions,
        dateFormat = _this$props3.dateFormat,
        refreshInterval = _this$props3.refreshInterval,
        refreshMinInterval = _this$props3.refreshMinInterval,
        refreshIntervalUnits = _this$props3.refreshIntervalUnits,
        isPaused = _this$props3.isPaused,
        isDisabled = _this$props3.isDisabled,
        isLoading = _this$props3.isLoading,
        locale = _this$props3.locale,
        timeFormat = _this$props3.timeFormat,
        utcOffset = _this$props3.utcOffset,
        compressed = _this$props3.compressed,
        onFocus = _this$props3.onFocus,
        styles = _this$props3.memoizedStyles;
      var autoRefreshAppend = !isPaused ? ___EmotionJSX(EuiAutoRefreshButton, {
        refreshInterval: refreshInterval,
        minInterval: refreshMinInterval,
        intervalUnits: refreshIntervalUnits,
        isDisabled: !!isDisabled,
        isPaused: isPaused,
        onRefreshChange: _this.onRefreshChange,
        shortHand: true
      }) : undefined;
      var formControlLayoutProps = {
        compressed: compressed,
        isInvalid: isInvalid,
        isLoading: isLoading && !showUpdateButton,
        disabled: !!isDisabled,
        prepend: _this.renderQuickSelect(),
        append: autoRefreshAppend,
        fullWidth: true,
        css: [styles.states.euiSuperDatePicker__formControlLayout, isDisabled ? styles.states.disabled : isInvalid ? styles.states.invalid : hasChanged ? styles.states.needsUpdating : styles.states.default]
      };
      if (isQuickSelectOnly) {
        return ___EmotionJSX(EuiFormControlLayout, _extends({
          iconsPosition: "static"
        }, formControlLayoutProps));
      }
      var isDisabledDisplay = isObject(isDisabled) && (isDisabled === null || isDisabled === void 0 ? void 0 : isDisabled.display);
      if (isDisabledDisplay || showPrettyDuration && !isStartDatePopoverOpen && !isEndDatePopoverOpen) {
        return ___EmotionJSX(EuiFormControlLayout, formControlLayoutProps, ___EmotionJSX("button", {
          type: "button",
          css: styles.euiSuperDatePicker__prettyFormat,
          className: classNames('euiSuperDatePicker__prettyFormat', {
            'euiSuperDatePicker__prettyFormat--disabled': isDisabled
          }),
          "data-test-subj": "superDatePickerShowDatesButton",
          disabled: !!isDisabled,
          onClick: _this.hidePrettyDuration,
          onFocus: onFocus
        }, isDisabledDisplay ? isDisabled.display : ___EmotionJSX(PrettyDuration, {
          timeFrom: start,
          timeTo: end,
          quickRanges: commonlyUsedRanges,
          dateFormat: dateFormat
        })));
      }
      var rangeCssStyles = [styles.euiSuperDatePicker__range, formControlLayoutProps.css];
      return ___EmotionJSX(EuiI18nConsumer, null, function (_ref4) {
        var contextLocale = _ref4.locale;
        return ___EmotionJSX(EuiDatePickerRange, _extends({}, formControlLayoutProps, {
          css: rangeCssStyles,
          isCustom: true,
          iconType: false,
          startDateControl: ___EmotionJSX(EuiDatePopoverButton, {
            css: styles.euiSuperDatePicker__rangeInput,
            className: "euiSuperDatePicker__startPopoverButton",
            compressed: compressed,
            position: "start",
            needsUpdating: hasChanged,
            isInvalid: isInvalid,
            isDisabled: !!isDisabled,
            onChange: _this.setStart,
            value: start,
            dateFormat: dateFormat,
            utcOffset: utcOffset,
            timeFormat: timeFormat,
            locale: locale || contextLocale,
            canRoundRelativeUnits: canRoundRelativeUnits,
            isOpen: _this.state.isStartDatePopoverOpen,
            onPopoverToggle: _this.onStartDatePopoverToggle,
            onPopoverClose: _this.onStartDatePopoverClose,
            timeOptions: timeOptions,
            buttonProps: {
              onFocus: onFocus
            }
          }),
          endDateControl: ___EmotionJSX(EuiDatePopoverButton, {
            css: styles.euiSuperDatePicker__rangeInput,
            position: "end",
            compressed: compressed,
            needsUpdating: hasChanged,
            isInvalid: isInvalid,
            isDisabled: !!isDisabled,
            onChange: _this.setEnd,
            value: end,
            dateFormat: dateFormat,
            utcOffset: utcOffset,
            timeFormat: timeFormat,
            locale: locale || contextLocale,
            canRoundRelativeUnits: canRoundRelativeUnits,
            roundUp: true,
            isOpen: _this.state.isEndDatePopoverOpen,
            onPopoverToggle: _this.onEndDatePopoverToggle,
            onPopoverClose: _this.onEndDatePopoverClose,
            timeOptions: timeOptions,
            buttonProps: {
              onFocus: onFocus
            }
          })
        }));
      });
    });
    _defineProperty(_this, "handleClickUpdateButton", function () {
      if (!_this.state.hasChanged && _this.props.onRefresh) {
        var _this$props4 = _this.props,
          start = _this$props4.start,
          end = _this$props4.end,
          refreshInterval = _this$props4.refreshInterval;
        _this.props.onRefresh({
          start: start,
          end: end,
          refreshInterval: refreshInterval
        });
      } else {
        _this.applyTime();
      }
    });
    _defineProperty(_this, "renderUpdateButton", function () {
      var _this$props5 = _this.props,
        isLoading = _this$props5.isLoading,
        isDisabled = _this$props5.isDisabled,
        updateButtonProps = _this$props5.updateButtonProps,
        showUpdateButton = _this$props5.showUpdateButton,
        compressed = _this$props5.compressed;
      if (!showUpdateButton) return null;
      return ___EmotionJSX(EuiSuperUpdateButton, _extends({
        needsUpdate: _this.state.hasChanged,
        showTooltip: !_this.state.isStartDatePopoverOpen && !_this.state.isEndDatePopoverOpen,
        isLoading: isLoading,
        isDisabled: !!isDisabled || _this.state.isInvalid,
        onClick: _this.handleClickUpdateButton,
        "data-test-subj": "superDatePickerApplyTimeButton",
        size: compressed ? 's' : 'm',
        iconOnly: showUpdateButton === 'iconOnly'
      }, updateButtonProps));
    });
    return _this;
  }
  _inherits(EuiSuperDatePickerInternal, _Component);
  return _createClass(EuiSuperDatePickerInternal, [{
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        isAutoRefreshOnly = _this$props6.isAutoRefreshOnly,
        isDisabled = _this$props6.isDisabled,
        isPaused = _this$props6.isPaused,
        onRefreshChange = _this$props6.onRefreshChange,
        refreshInterval = _this$props6.refreshInterval,
        refreshMinInterval = _this$props6.refreshMinInterval,
        refreshIntervalUnits = _this$props6.refreshIntervalUnits,
        showUpdateButton = _this$props6.showUpdateButton,
        dataTestSubj = _this$props6['data-test-subj'],
        _width = _this$props6.width,
        isQuickSelectOnly = _this$props6.isQuickSelectOnly,
        compressed = _this$props6.compressed,
        className = _this$props6.className,
        styles = _this$props6.memoizedStyles;
      var _this$state2 = this.state,
        hasChanged = _this$state2.hasChanged,
        isInvalid = _this$state2.isInvalid;
      var classes = classNames('euiSuperDatePicker', className, {
        'euiSuperDatePicker--needsUpdating': hasChanged && !isDisabled && !isInvalid
      });

      // Force reduction in width if showing quick select only
      var width = isQuickSelectOnly ? 'auto' : _width !== null && _width !== void 0 ? _width : 'restricted';
      var cssStyles = [styles.euiSuperDatePicker, styles.widths[width], !showUpdateButton && styles.noUpdateButton[width], isAutoRefreshOnly && styles.isAutoRefreshOnly[width], isQuickSelectOnly && styles.isQuickSelectOnly];
      return ___EmotionJSX("div", {
        css: cssStyles,
        className: classes,
        "data-test-subj": dataTestSubj
      }, isAutoRefreshOnly && onRefreshChange ? ___EmotionJSX(EuiAutoRefresh, {
        isPaused: isPaused,
        refreshInterval: refreshInterval,
        minInterval: refreshMinInterval,
        intervalUnits: refreshIntervalUnits,
        onRefreshChange: this.onRefreshChange,
        fullWidth: width === 'full',
        compressed: compressed,
        isDisabled: !!isDisabled,
        className: className
      }) : ___EmotionJSX(React.Fragment, null, this.renderDatePickerRange(), this.renderUpdateButton()));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.start !== prevState.prevProps.start || nextProps.end !== prevState.prevProps.end) {
        return {
          prevProps: {
            start: nextProps.start,
            end: nextProps.end
          },
          start: nextProps.start,
          end: nextProps.end,
          isInvalid: isRangeInvalid(nextProps.start, nextProps.end),
          hasChanged: false,
          showPrettyDuration: showPrettyDuration(nextProps.start, nextProps.end, nextProps.commonlyUsedRanges)
        };
      }
      return null;
    }
  }]);
}(Component);

// Because EuiSuperDatePicker is a class component and not a functional component,
// we have to use a render prop here in order for us to pass i18n'd strings/objects/etc
// to all underlying usages of our timeOptions constants. If someday we convert
// EuiSuperDatePicker to an FC, we can likely get rid of this wrapper.
_defineProperty(EuiSuperDatePickerInternal, "defaultProps", {
  dateFormat: 'MMM D, YYYY @ HH:mm:ss.SSS',
  end: 'now',
  isAutoRefreshOnly: false,
  isDisabled: false,
  isPaused: true,
  recentlyUsedRanges: [],
  refreshInterval: 1000,
  showUpdateButton: true,
  canRoundRelativeUnits: true,
  start: 'now-15m',
  timeFormat: 'HH:mm',
  width: 'restricted'
});
EuiSuperDatePickerInternal.propTypes = {
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string,
  css: PropTypes.any,
  // The below options are marked as required because they have default fallbacks
  commonlyUsedRanges: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    end: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired,
    label: PropTypes.string,
    start: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired
  }).isRequired), PropTypes.arrayOf(PropTypes.shape({
    end: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired,
    label: PropTypes.string,
    start: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired
  }).isRequired).isRequired]),
  customQuickSelectPanels: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.element.isRequired
  }).isRequired),
  /**
     * An optional render prop function that allows customizing the display of the Quick Select menu.
     * This function passes all default quick select panels within an object, allowing you to
     * re-order panels, omit certain panels entirely, or pass in your own fully custom content.
     */
  customQuickSelectRender: PropTypes.func,
  /**
     * Specifies the formatted used when displaying dates and/or datetimes
     * @default 'MMM D, YYYY @ HH:mm:ss.SSS'
     */
  dateFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.string.isRequired]),
  /**
     * Set isAutoRefreshOnly to true to limit the component to only display auto refresh content.
     */
  isAutoRefreshOnly: PropTypes.bool,
  /**
     * Accepts either a true/false boolean or an object configuration.
     *
     * The configuration will render the component as disabled, and allow you to
     * customize the displayed disabled text.
     */
  isDisabled: PropTypes.oneOfType([PropTypes.bool.isRequired, PropTypes.shape({
    display: PropTypes.node.isRequired
  }).isRequired]),
  isLoading: PropTypes.bool,
  /**
     * @default true
     */
  isPaused: PropTypes.oneOfType([PropTypes.bool, PropTypes.bool.isRequired]),
  /**
     * Sets the overall width by adding sensible min and max widths.
     * - `auto`: fits width to internal content / time string.
     * - `restricted`: static width that fits the longest possible time string.
     * - `full`: expands to 100% of the container.
     * @default 'restricted'
     */
  width: PropTypes.oneOf(["restricted", "full", "auto"]),
  /**
     * Reduces overall height to compressed form size
     */
  compressed: PropTypes.bool,
  /**
     * Used to localize e.g. month names, passed to `moment`
     */
  locale: PropTypes.any,
  /**
     * Triggered whenever the EuiSuperDatePicker's dates are focused
     */
  onFocus: PropTypes.any,
  /**
     * Callback for when the refresh interval is fired.
     * EuiSuperDatePicker will only manage a refresh interval timer when onRefresh callback is supplied
     * If a promise is returned, the next refresh interval will not start until the promise has resolved.
     * If the promise rejects the refresh interval will stop and the error thrown
     */
  onRefresh: PropTypes.func,
  /**
     * Callback for when the refresh interval changes.
     * Supply onRefreshChange to show refresh interval inputs in quick select popover
     */
  onRefreshChange: PropTypes.func,
  /**
     * Callback for when the time changes.
     */
  onTimeChange: PropTypes.func.isRequired,
  recentlyUsedRanges: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    end: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired,
    label: PropTypes.string,
    start: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired
  }).isRequired), PropTypes.arrayOf(PropTypes.shape({
    end: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired,
    label: PropTypes.string,
    start: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired
  }).isRequired).isRequired]),
  refreshInterval: PropTypes.oneOfType([PropTypes.number, PropTypes.number.isRequired]),
  refreshMinInterval: PropTypes.number,
  /**
     * By default, refresh interval units will be rounded up to next largest unit of time
     * (for example, 90 seconds will become 2m).
     *
     * If you do not want this behavior, you will need to store the user-set `intervalUnits`
     * (passed by `onRefreshChange`) and manually control it via this prop.
     */
  refreshIntervalUnits: PropTypes.any,
  start: PropTypes.oneOfType([PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]), PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired]),
  end: PropTypes.oneOfType([PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]), PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired]),
  /**
     * Specifies the formatted used when displaying times
     * @default 'HH:mm'
     */
  timeFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.string.isRequired]),
  utcOffset: PropTypes.number,
  /**
     * Set showUpdateButton to false to immediately invoke onTimeChange for all start and end changes.
     * @default true
     */
  showUpdateButton: PropTypes.oneOfType([PropTypes.bool.isRequired, PropTypes.oneOf(["iconOnly"])]),
  /**
     * Hides the actual input reducing to just the quick select button.
     */
  isQuickSelectOnly: PropTypes.bool,
  /**
     * Props passed to the update button #EuiSuperUpdateButtonProps
     */
  updateButtonProps: PropTypes.shape({
    /**
       * Overrides the default button label with a custom React node.
       *
       * When defined, you're responsible for updating the custom label
       * when the data needs updating (the `needsUpdate` prop)
       * or is loading (the `isLoading` prop).
       */
    children: PropTypes.node,
    /**
       * Show the "Click to apply" tooltip
       */
    showTooltip: PropTypes.bool,
    /**
       * Passes props to `EuiToolTip`
       */
    toolTipProps: PropTypes.any,
    /**
       * Returns an IconButton instead
       */
    iconOnly: PropTypes.bool,
    /**
       * Forces state to be `iconOnly` when within provided breakpoints.
       * Remove completely with `false` or provide your own list of breakpoints.
       */
    responsive: PropTypes.oneOfType([PropTypes.oneOf([false]), PropTypes.arrayOf(PropTypes.any.isRequired).isRequired])
  }),
  /**
     * By default, relative units will be rounded up to next largest unit of time
     * (for example, 90 minutes will become ~ 2 hours).
     *
     * If you do not want this behavior and instead wish to keep the exact units
     * input by the user, set this flag to `false`.
     */
  canRoundRelativeUnits: PropTypes.bool,
  memoizedStyles: PropTypes.any.isRequired,
  timeOptions: PropTypes.shape({
    timeTenseOptions: PropTypes.arrayOf(PropTypes.any.isRequired).isRequired,
    timeUnitsOptions: PropTypes.arrayOf(PropTypes.any.isRequired).isRequired,
    relativeOptions: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.oneOf(["s", "m", "h", "d", "w", "M", "y"]).isRequired, PropTypes.oneOf(["s+", "m+", "h+", "d+", "w+", "M+", "y+"]).isRequired]).isRequired
    }).isRequired).isRequired,
    relativeRoundingLabels: PropTypes.any.isRequired,
    refreshUnitsOptions: PropTypes.arrayOf(PropTypes.any.isRequired).isRequired,
    commonDurationRanges: PropTypes.arrayOf(PropTypes.shape({
      end: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired,
      label: PropTypes.string,
      start: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired
    }).isRequired).isRequired
  }).isRequired
};
export var EuiSuperDatePicker = props => {
  const styles = useEuiMemoizedStyles(euiSuperDatePickerStyles);
  return <RenderI18nTimeOptions>
      {timeOptions => <EuiSuperDatePickerInternal {...props} timeOptions={timeOptions} commonlyUsedRanges={props.commonlyUsedRanges || timeOptions.commonDurationRanges} memoizedStyles={styles} />}
    </RenderI18nTimeOptions>;
};
EuiSuperDatePicker.propTypes = {
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string,
  css: PropTypes.any,
  commonlyUsedRanges: PropTypes.arrayOf(PropTypes.shape({
    end: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired,
    label: PropTypes.string,
    start: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired
  }).isRequired),
  customQuickSelectPanels: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.element.isRequired
  }).isRequired),
  /**
     * An optional render prop function that allows customizing the display of the Quick Select menu.
     * This function passes all default quick select panels within an object, allowing you to
     * re-order panels, omit certain panels entirely, or pass in your own fully custom content.
     */
  customQuickSelectRender: PropTypes.func,
  /**
     * Specifies the formatted used when displaying dates and/or datetimes
     * @default 'MMM D, YYYY @ HH:mm:ss.SSS'
     */
  dateFormat: PropTypes.string,
  /**
     * Set isAutoRefreshOnly to true to limit the component to only display auto refresh content.
     */
  isAutoRefreshOnly: PropTypes.bool,
  /**
     * Accepts either a true/false boolean or an object configuration.
     *
     * The configuration will render the component as disabled, and allow you to
     * customize the displayed disabled text.
     */
  isDisabled: PropTypes.oneOfType([PropTypes.bool.isRequired, PropTypes.shape({
    display: PropTypes.node.isRequired
  }).isRequired]),
  isLoading: PropTypes.bool,
  /**
     * @default true
     */
  isPaused: PropTypes.bool,
  /**
     * Sets the overall width by adding sensible min and max widths.
     * - `auto`: fits width to internal content / time string.
     * - `restricted`: static width that fits the longest possible time string.
     * - `full`: expands to 100% of the container.
     * @default 'restricted'
     */
  width: PropTypes.oneOf(["restricted", "full", "auto"]),
  /**
     * Reduces overall height to compressed form size
     */
  compressed: PropTypes.bool,
  /**
     * Used to localize e.g. month names, passed to `moment`
     */
  locale: PropTypes.any,
  /**
     * Triggered whenever the EuiSuperDatePicker's dates are focused
     */
  onFocus: PropTypes.any,
  /**
     * Callback for when the refresh interval is fired.
     * EuiSuperDatePicker will only manage a refresh interval timer when onRefresh callback is supplied
     * If a promise is returned, the next refresh interval will not start until the promise has resolved.
     * If the promise rejects the refresh interval will stop and the error thrown
     */
  onRefresh: PropTypes.func,
  /**
     * Callback for when the refresh interval changes.
     * Supply onRefreshChange to show refresh interval inputs in quick select popover
     */
  onRefreshChange: PropTypes.func,
  /**
     * Callback for when the time changes.
     */
  onTimeChange: PropTypes.func.isRequired,
  recentlyUsedRanges: PropTypes.arrayOf(PropTypes.shape({
    end: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired,
    label: PropTypes.string,
    start: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired
  }).isRequired),
  /**
     * Minimum refresh interval in milliseconds
     * @default 0
     */
  refreshInterval: PropTypes.number,
  refreshMinInterval: PropTypes.number,
  /**
     * By default, refresh interval units will be rounded up to next largest unit of time
     * (for example, 90 seconds will become 2m).
     *
     * If you do not want this behavior, you will need to store the user-set `intervalUnits`
     * (passed by `onRefreshChange`) and manually control it via this prop.
     */
  refreshIntervalUnits: PropTypes.any,
  /**
     * @default 'now'
     */
  start: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]),
  end: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]),
  /**
     * Specifies the formatted used when displaying times
     * @default 'HH:mm'
     */
  timeFormat: PropTypes.string,
  utcOffset: PropTypes.number,
  /**
     * Set showUpdateButton to false to immediately invoke onTimeChange for all start and end changes.
     * @default true
     */
  showUpdateButton: PropTypes.oneOfType([PropTypes.bool.isRequired, PropTypes.oneOf(["iconOnly"])]),
  /**
     * Hides the actual input reducing to just the quick select button.
     */
  isQuickSelectOnly: PropTypes.bool,
  /**
     * Props passed to the update button #EuiSuperUpdateButtonProps
     */
  updateButtonProps: PropTypes.shape({
    children: PropTypes.node,
    showTooltip: PropTypes.bool,
    toolTipProps: PropTypes.any,
    iconOnly: PropTypes.bool,
    responsive: PropTypes.oneOfType([PropTypes.oneOf([false]), PropTypes.arrayOf(PropTypes.any.isRequired).isRequired])
  }),
  /**
     * By default, relative units will be rounded up to next largest unit of time
     * (for example, 90 minutes will become ~ 2 hours).
     *
     * If you do not want this behavior and instead wish to keep the exact units
     * input by the user, set this flag to `false`.
     */
  canRoundRelativeUnits: PropTypes.bool
};
try {
  EuiSuperDatePickerInternal.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
    description: '',
    displayName: 'EuiSuperDatePickerInternal',
    methods: [],
    props: {
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-label': {
        defaultValue: null,
        description: '',
        name: 'aria-label',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'data-test-subj': {
        defaultValue: null,
        description: '',
        name: 'data-test-subj',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      css: {
        defaultValue: null,
        description: '',
        name: 'css',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'Interpolation<Theme>'
        }
      },
      commonlyUsedRanges: {
        defaultValue: null,
        description: '',
        name: 'commonlyUsedRanges',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }, {
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'DurationRange[]'
        }
      },
      customQuickSelectPanels: {
        defaultValue: null,
        description: '',
        name: 'customQuickSelectPanels',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'QuickSelectPanel[]'
        }
      },
      customQuickSelectRender: {
        defaultValue: null,
        description: 'An optional render prop function that allows customizing the display of the Quick Select menu.\n' + 'This function passes all default quick select panels within an object, allowing you to\n' + 're-order panels, omit certain panels entirely, or pass in your own fully custom content.',
        name: 'customQuickSelectRender',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: '(options: CustomQuickSelectRenderOptions) => ReactNode'
        }
      },
      dateFormat: {
        defaultValue: {
          value: 'MMM D, YYYY @ HH:mm:ss.SSS'
        },
        description: 'Specifies the formatted used when displaying dates and/or datetimes',
        name: 'dateFormat',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }, {
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      isAutoRefreshOnly: {
        defaultValue: {
          value: 'false'
        },
        description: 'Set isAutoRefreshOnly to true to limit the component to only display auto refresh content.',
        name: 'isAutoRefreshOnly',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      isDisabled: {
        defaultValue: {
          value: 'false'
        },
        description: 'Accepts either a true/false boolean or an object configuration.\n' + '\n' + 'The configuration will render the component as disabled, and allow you to\n' + 'customize the displayed disabled text.',
        name: 'isDisabled',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean | { display: ReactNode; }'
        }
      },
      isLoading: {
        defaultValue: null,
        description: '',
        name: 'isLoading',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      isPaused: {
        defaultValue: {
          value: 'true'
        },
        description: '',
        name: 'isPaused',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }, {
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      width: {
        defaultValue: {
          value: 'restricted'
        },
        description: 'Sets the overall width by adding sensible min and max widths.\n' + '- `auto`: fits width to internal content / time string.\n' + '- `restricted`: static width that fits the longest possible time string.\n' + '- `full`: expands to 100% of the container.',
        name: 'width',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: '"auto" | "restricted" | "full"',
          value: [{
            value: '"auto"'
          }, {
            value: '"restricted"'
          }, {
            value: '"full"'
          }]
        }
      },
      compressed: {
        defaultValue: null,
        description: 'Reduces overall height to compressed form size',
        name: 'compressed',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      locale: {
        defaultValue: null,
        description: 'Used to localize e.g. month names, passed to `moment`',
        name: 'locale',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'LocaleSpecifier'
        }
      },
      onFocus: {
        defaultValue: null,
        description: "Triggered whenever the EuiSuperDatePicker's dates are focused",
        name: 'onFocus',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'FocusEventHandler<Element>'
        }
      },
      onRefresh: {
        defaultValue: null,
        description: 'Callback for when the refresh interval is fired.\n' + 'EuiSuperDatePicker will only manage a refresh interval timer when onRefresh callback is supplied\n' + 'If a promise is returned, the next refresh interval will not start until the promise has resolved.\n' + 'If the promise rejects the refresh interval will stop and the error thrown',
        name: 'onRefresh',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: '(props: OnRefreshProps) => void'
        }
      },
      onRefreshChange: {
        defaultValue: null,
        description: 'Callback for when the refresh interval changes.\n' + 'Supply onRefreshChange to show refresh interval inputs in quick select popover',
        name: 'onRefreshChange',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'ApplyRefreshInterval'
        }
      },
      onTimeChange: {
        defaultValue: null,
        description: 'Callback for when the time changes.',
        name: 'onTimeChange',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '(props: OnTimeChangeProps) => void'
        }
      },
      recentlyUsedRanges: {
        defaultValue: {
          value: '[]'
        },
        description: '',
        name: 'recentlyUsedRanges',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }, {
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'DurationRange[]'
        }
      },
      refreshInterval: {
        defaultValue: {
          value: '1000'
        },
        description: 'Refresh interval in milliseconds',
        name: 'refreshInterval',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }, {
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'number'
        }
      },
      refreshMinInterval: {
        defaultValue: {
          value: '0'
        },
        description: 'Minimum refresh interval in milliseconds',
        name: 'refreshMinInterval',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'number'
        }
      },
      refreshIntervalUnits: {
        defaultValue: null,
        description: 'By default, refresh interval units will be rounded up to next largest unit of time\n' + '(for example, 90 seconds will become 2m).\n' + '\n' + 'If you do not want this behavior, you will need to store the user-set `intervalUnits`\n' + '(passed by `onRefreshChange`) and manually control it via this prop.',
        name: 'refreshIntervalUnits',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: '"s" | "m" | "h"',
          value: [{
            value: '"s"'
          }, {
            value: '"m"'
          }, {
            value: '"h"'
          }]
        }
      },
      start: {
        defaultValue: {
          value: 'now-15m'
        },
        description: '',
        name: 'start',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }, {
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      end: {
        defaultValue: {
          value: 'now'
        },
        description: '',
        name: 'end',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }, {
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      timeFormat: {
        defaultValue: {
          value: 'HH:mm'
        },
        description: 'Specifies the formatted used when displaying times',
        name: 'timeFormat',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }, {
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      utcOffset: {
        defaultValue: null,
        description: '',
        name: 'utcOffset',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'number'
        }
      },
      showUpdateButton: {
        defaultValue: {
          value: 'true'
        },
        description: 'Set showUpdateButton to false to immediately invoke onTimeChange for all start and end changes.',
        name: 'showUpdateButton',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean | "iconOnly"'
        }
      },
      isQuickSelectOnly: {
        defaultValue: null,
        description: 'Hides the actual input reducing to just the quick select button.',
        name: 'isQuickSelectOnly',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      updateButtonProps: {
        defaultValue: null,
        description: 'Props passed to the update button #EuiSuperUpdateButtonProps',
        name: 'updateButtonProps',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'EuiSuperUpdateButtonProps'
        }
      },
      canRoundRelativeUnits: {
        defaultValue: {
          value: 'true'
        },
        description: 'By default, relative units will be rounded up to next largest unit of time\n' + '(for example, 90 minutes will become ~ 2 hours).\n' + '\n' + 'If you do not want this behavior and instead wish to keep the exact units\n' + 'input by the user, set this flag to `false`.',
        name: 'canRoundRelativeUnits',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      memoizedStyles: {
        defaultValue: null,
        description: '',
        name: 'memoizedStyles',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '{ euiSuperDatePicker: SerializedStyles; widths: { restricted: SerializedStyles; full: SerializedStyles; auto: SerializedStyles; }; ... 6 more ...; states: { ...; }; }'
        }
      },
      timeOptions: {
        defaultValue: null,
        description: '',
        name: 'timeOptions',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'TimeOptions'
        }
      }
    },
    extendedInterfaces: ['CommonProps']
  };
} catch (e) {}
try {
  EuiSuperDatePicker.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
    description: '',
    displayName: 'EuiSuperDatePicker',
    methods: [],
    props: {
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-label': {
        defaultValue: null,
        description: '',
        name: 'aria-label',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'data-test-subj': {
        defaultValue: null,
        description: '',
        name: 'data-test-subj',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      css: {
        defaultValue: null,
        description: '',
        name: 'css',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'Interpolation<Theme>'
        }
      },
      commonlyUsedRanges: {
        defaultValue: null,
        description: '',
        name: 'commonlyUsedRanges',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'DurationRange[]'
        }
      },
      customQuickSelectPanels: {
        defaultValue: null,
        description: '',
        name: 'customQuickSelectPanels',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'QuickSelectPanel[]'
        }
      },
      customQuickSelectRender: {
        defaultValue: null,
        description: 'An optional render prop function that allows customizing the display of the Quick Select menu.\n' + 'This function passes all default quick select panels within an object, allowing you to\n' + 're-order panels, omit certain panels entirely, or pass in your own fully custom content.',
        name: 'customQuickSelectRender',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: '(options: CustomQuickSelectRenderOptions) => ReactNode'
        }
      },
      dateFormat: {
        defaultValue: {
          value: "'MMM D, YYYY @ HH:mm:ss.SSS'"
        },
        description: 'Specifies the formatted used when displaying dates and/or datetimes',
        name: 'dateFormat',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      isAutoRefreshOnly: {
        defaultValue: null,
        description: 'Set isAutoRefreshOnly to true to limit the component to only display auto refresh content.',
        name: 'isAutoRefreshOnly',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      isDisabled: {
        defaultValue: null,
        description: 'Accepts either a true/false boolean or an object configuration.\n' + '\n' + 'The configuration will render the component as disabled, and allow you to\n' + 'customize the displayed disabled text.',
        name: 'isDisabled',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean | { display: ReactNode; }'
        }
      },
      isLoading: {
        defaultValue: null,
        description: '',
        name: 'isLoading',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      isPaused: {
        defaultValue: {
          value: 'true'
        },
        description: '',
        name: 'isPaused',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      width: {
        defaultValue: {
          value: "'restricted'"
        },
        description: 'Sets the overall width by adding sensible min and max widths.\n' + '- `auto`: fits width to internal content / time string.\n' + '- `restricted`: static width that fits the longest possible time string.\n' + '- `full`: expands to 100% of the container.',
        name: 'width',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: '"auto" | "restricted" | "full"',
          value: [{
            value: '"auto"'
          }, {
            value: '"restricted"'
          }, {
            value: '"full"'
          }]
        }
      },
      compressed: {
        defaultValue: null,
        description: 'Reduces overall height to compressed form size',
        name: 'compressed',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      locale: {
        defaultValue: null,
        description: 'Used to localize e.g. month names, passed to `moment`',
        name: 'locale',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'LocaleSpecifier'
        }
      },
      onFocus: {
        defaultValue: null,
        description: "Triggered whenever the EuiSuperDatePicker's dates are focused",
        name: 'onFocus',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'FocusEventHandler<Element>'
        }
      },
      onRefresh: {
        defaultValue: null,
        description: 'Callback for when the refresh interval is fired.\n' + 'EuiSuperDatePicker will only manage a refresh interval timer when onRefresh callback is supplied\n' + 'If a promise is returned, the next refresh interval will not start until the promise has resolved.\n' + 'If the promise rejects the refresh interval will stop and the error thrown',
        name: 'onRefresh',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: '(props: OnRefreshProps) => void'
        }
      },
      onRefreshChange: {
        defaultValue: null,
        description: 'Callback for when the refresh interval changes.\n' + 'Supply onRefreshChange to show refresh interval inputs in quick select popover',
        name: 'onRefreshChange',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'ApplyRefreshInterval'
        }
      },
      onTimeChange: {
        defaultValue: null,
        description: 'Callback for when the time changes.',
        name: 'onTimeChange',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '(props: OnTimeChangeProps) => void'
        }
      },
      recentlyUsedRanges: {
        defaultValue: null,
        description: '',
        name: 'recentlyUsedRanges',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'DurationRange[]'
        }
      },
      refreshInterval: {
        defaultValue: {
          value: '1000'
        },
        description: 'Refresh interval in milliseconds',
        name: 'refreshInterval',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'number'
        }
      },
      refreshMinInterval: {
        defaultValue: {
          value: '0'
        },
        description: 'Minimum refresh interval in milliseconds',
        name: 'refreshMinInterval',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'number'
        }
      },
      refreshIntervalUnits: {
        defaultValue: null,
        description: 'By default, refresh interval units will be rounded up to next largest unit of time\n' + '(for example, 90 seconds will become 2m).\n' + '\n' + 'If you do not want this behavior, you will need to store the user-set `intervalUnits`\n' + '(passed by `onRefreshChange`) and manually control it via this prop.',
        name: 'refreshIntervalUnits',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: '"s" | "m" | "h"',
          value: [{
            value: '"s"'
          }, {
            value: '"m"'
          }, {
            value: '"h"'
          }]
        }
      },
      start: {
        defaultValue: {
          value: "'now-15m'"
        },
        description: '',
        name: 'start',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      end: {
        defaultValue: {
          value: "'now'"
        },
        description: '',
        name: 'end',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      timeFormat: {
        defaultValue: {
          value: "'HH:mm'"
        },
        description: 'Specifies the formatted used when displaying times',
        name: 'timeFormat',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      utcOffset: {
        defaultValue: null,
        description: '',
        name: 'utcOffset',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'number'
        }
      },
      showUpdateButton: {
        defaultValue: {
          value: 'true'
        },
        description: 'Set showUpdateButton to false to immediately invoke onTimeChange for all start and end changes.',
        name: 'showUpdateButton',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean | "iconOnly"'
        }
      },
      isQuickSelectOnly: {
        defaultValue: null,
        description: 'Hides the actual input reducing to just the quick select button.',
        name: 'isQuickSelectOnly',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      updateButtonProps: {
        defaultValue: null,
        description: 'Props passed to the update button #EuiSuperUpdateButtonProps',
        name: 'updateButtonProps',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'EuiSuperUpdateButtonProps'
        }
      },
      canRoundRelativeUnits: {
        defaultValue: null,
        description: 'By default, relative units will be rounded up to next largest unit of time\n' + '(for example, 90 minutes will become ~ 2 hours).\n' + '\n' + 'If you do not want this behavior and instead wish to keep the exact units\n' + 'input by the user, set this flag to `false`.',
        name: 'canRoundRelativeUnits',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/date_picker/super_date_picker/super_date_picker.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      }
    },
    extendedInterfaces: ['CommonProps']
  };
} catch (e) {}